import React, { Component } from 'react'
import { navigate } from 'gatsby'
import Select from 'react-select'
import Link from '../utils/link'
import { getMarketoCookie } from '../utils/marketo'
import { readCookie, parseCookieToObject } from '../utils/cookie'

const priceMin = [
  { label: "$600,000", value: 700000},
  { label: "$800,000", value: 800000},
  { label: "$1,000,000", value: 1000000},
  { label: "$1,200,000", value: 1200000},
  { label: "$1,400,000", value: 1400000},
  { label: "$1,600,000", value: 1600000},
  { label: "$1,800,000", value: 1800000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,200,000", value: 2200000},
  { label: "$2,400,000", value: 2400000},
  { label: "$2,600,000", value: 2600000},
  { label: "$2,800,000", value: 2800000},
  { label: "$3,000,000", value: 3000000},
]

const priceMax = [
  { label: "$800,000", value: 800000},
  { label: "$1,000,000", value: 1000000},
  { label: "$1,200,000", value: 1200000},
  { label: "$1,400,000", value: 1400000},
  { label: "$1,600,000", value: 1600000},
  { label: "$1,800,000", value: 1800000},
  { label: "$2,000,000", value: 2000000},
  { label: "$2,200,000", value: 2200000},
  { label: "$2,400,000", value: 2400000},
  { label: "$2,600,000", value: 2600000},
  { label: "$2,800,000", value: 2800000},
  { label: "$3,000,000+", value: 3000000},
]

const bed_bath_park = [
  { label: "1+", value: 1},
  { label: "2+", value: 2},
  { label: "3+", value: 3},
  { label: "4+", value: 4},
  { label: "5+", value: 5},
  { label: "6+", value: 6}
]

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class OffMarketForm extends Component {

  state = {
    suburb: '',
    property_type: '',
    property_types: [],
    price_min: null,
    price_max: null,
    firstname: null,
    lastname: null,
    email: null,
    mobile: null,
    contact_method: null,
    register: true,
    is_website: true,
    items: [true],
    errors: {
      suburb: false,
      price_min: false,
      price_max: false,
    },
    form_name: 'Off Market',
    agent_email: 'andrewm@kollosche.com.au',
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  componentDidMount() {
    let cookie = getMarketoCookie()
    this.setState({ cookie })
  }

  handleChange = e => {
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name]: e.target.checked })
    } else {
      this.setState({ [e.target.name]: e.target.value })
    }
  }

  handleCheckChange = e => {
    // push to this.state.property_types array if not already in array / if in array remove it
    let property_types = this.state.property_types
    if (property_types.includes(e.target.value)) {
      property_types = property_types.filter(type => type !== e.target.value)
    } else {
      property_types.push(e.target.value)
    }
     // convert thie.state.property_types array to a string and save it to this.state.property_type
    this.setState({ 
      property_type: property_types.join(', '),
      property_types
    })
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        this.setState(state)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state)
        break
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    let message = `
      Off Market Form Submission

      ${this.state.property_type}
      ${this.state.address}


      Bed :: ${this.state.bedrooms?.value}
      Bath :: ${this.state.bathrooms?.value}
      Car :: ${this.state.carparks?.value}
      MinPrice :: ${this.state.price_min?.value}
      MaxPrice :: ${this.state.price_max?.value}

      Contact Method :: ${this.state.contact_method}
    `

    let state = this.state
    for (let key in state) {
      if (key === 'items') continue;
      if (typeof state[key] === 'object' && state[key] !== null && state[key].hasOwnProperty('value')) {
        state[key] = state[key].value;
      }
    }

    let utmFromCookie = readCookie('utmParameters');
    utmFromCookie = parseCookieToObject(utmFromCookie)

    return fetch(`https://kollosche.codedrips.com/wp-json/team/v1/enquiry`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        message,
        ...utmFromCookie,
        ...state
      })
    })
    .then(res => res.json())
    .then((res) => {
      console.log(res.response)
      if (res?.response?.status === 'success') navigate('/off-market/thank-you/')
      if (res?.response?.errors) {
        this.setState({
          result: 'fail',
          msg: res.response.errors.map(err => err.detail.split('\n').map((el, i) => <div key={i}>{ el }</div>))
        }) 
      }
    })
    .catch(error => this.setState({result: 'fail', msg: error}))
    .finally(() => {
      // Re-enable the submit button after the request completes
      this.setState({ isSubmitting: false })
    });
  }

  _handleBackStep = () => {
    let items = [];
    items[0] = true;
    this.setState({ items: items})
  }

  _handleNextStep = () => {
    const { suburb, price_min, price_max, bedrooms, bathrooms, carparks } = this.state;
    let errors = {};

    // Validate each field and set error to true if the field is empty
    errors.suburb = !suburb;
    errors.price_min = !price_min;
    errors.price_max = !price_max;

    // If any errors are found, update the state
    if (Object.values(errors).some(error => error)) {
      this.setState({ errors });
    } else {
      // If no errors, proceed to next step
      let items = [];
      items[1] = true;
      this.setState({ items, errors: {} });
    }
  };

  render() {
    let { items, suburb, bedrooms, bathrooms, carparks, price_min, price_max, errors } = this.state

    let props = {
      ref: this.form,
      name: 'offmarket',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    return (

      <form {...props}>
        { this.state.msg && <div className='error'>{ this.state.msg }</div> }

        <div className={`form-fields ${items[0] ? 'active' : ''} `}>

          <h4>What are you looking to buy?</h4>
          <div className='instructions'>Sharing a little about your needs will enable our team to select off-market listings that best suit your preferences, from both our current and future listings. </div>

          <div className='form__row'>

            <label htmlFor='address-field'> Location/s you’re interested in </label>

            <input type='text' name='suburb' id='address-field' className='form__input' defaultValue={suburb} onChange={this.handleChange} required />

            {errors.suburb && <div className="error">Please enter a suburb.</div>}

          </div>

          <div className='form__row'>

            <label htmlFor='property-type-field'> Property Type </label>

            <div className='form__checkbox-group'>

              <div className='form__checkbox'>
                <input type='checkbox' id='all-radio-field' name="property_type" value="All" onChange={this.handleCheckChange} />
                <label htmlFor='all-radio-field'>All</label>
              </div>

              <div className='form__checkbox'>
                <input type='checkbox' id='house-radio-field' name="property_type" value="House" onChange={this.handleCheckChange} />
                <label htmlFor='house-radio-field'>House </label>
              </div>

              <div className='form__checkbox'>
                <input type='checkbox' id='apartment-radio-field' name="property_type" value="Apartment" onChange={this.handleCheckChange} />
                <label htmlFor='apartment-radio-field'>Apartment</label>
              </div>

              <div className='form__checkbox'>
                <input type='checkbox' id='townhouse-radio-field' name="property_type" value="Townhouse" onChange={this.handleCheckChange} />
                <label htmlFor='townhouse-radio-field'>Townhouse</label>
              </div>

              <div className='form__checkbox'>
                <input type='checkbox' id='commerical-radio-field' name="property_type" value="Commerical" onChange={this.handleCheckChange} />
                <label htmlFor='commerical-radio-field'>Commerical</label>
              </div>

              <div className='form__checkbox'>
                <input type='checkbox' id='land-radio-field' name="property_type" value="Land" onChange={this.handleCheckChange} />
                <label htmlFor='land-radio-field'>Land</label>
              </div>

            </div>

          </div>

          <div className="form__row form__row--dropdowns form__row--double">

            <div className='form__select form__select--min' onMouseOver={() => this.min.focus()} onMouseLeave={() => this.min.blur()}>
              <Select
                options={priceMin}
                onChange={this.handleSelectChange}
                openMenuOnFocus={true}
                id="price_min"
                name="price_min"
                value={price_min}
                placeholder="Min Price"
                className="react-select-container"
                classNamePrefix="react-select"
                ref={node => this.min = node}
              />
              {errors.price_min && <div className="error">Please select a minimum price.</div>}
            </div>

            <div className='form__select form__select--max' onMouseOver={() => this.max.focus()} onMouseLeave={() => this.max.blur()}>
              <Select
                options={priceMax}
                onChange={this.handleSelectChange}
                openMenuOnFocus={true}
                id="price_max"
                name="price_max"
                value={price_max}
                placeholder="Max Price"
                className="react-select-container"
                classNamePrefix="react-select"
                required={true}
                ref={node => this.max = node}
              />
              {errors.price_max && <div className="error">Please select a maximum price.</div>}
            </div>

        </div>

        <div className="form__row form__row--dropdowns form__row--triple">

          <div className='form__select form__select--bed' onMouseOver={() => this.bed.focus()} onMouseLeave={() => this.bed.blur()}>
            <Select
              options={bed_bath_park}
              onChange={this.handleSelectChange}
              openMenuOnFocus={true}
              id="bedrooms"
              name="bedrooms"
              value={bedrooms}
              placeholder="Beds"
              className="react-select-container"
              classNamePrefix="react-select"
              ref={node => this.bed = node}
            />
          </div>

          <div className='form__select form__select--bath' onMouseOver={() => this.bath.focus()} onMouseLeave={() => this.bath.blur()}>
            <Select
              options={bed_bath_park}
              onChange={this.handleSelectChange}
              openMenuOnFocus={true}
              id="bathrooms"
              name="bathrooms"
              value={bathrooms}
              placeholder="Baths"
              className="react-select-container"
              classNamePrefix="react-select"
              ref={node => this.bath = node}
            />
          </div>

          <div className='form__select form__select--car' onMouseOver={() => this.car.focus()} onMouseLeave={() => this.car.blur()}>
            <Select
              options={bed_bath_park}
              onChange={this.handleSelectChange}
              openMenuOnFocus={true}
              id="carparks"
              name="carparks"
              value={carparks}
              placeholder="Cars"
              className="react-select-container"
              classNamePrefix="react-select"
              ref={node => this.car = node}
            />
          </div>

        </div>

        <div className='form__row form__row--submit'>

          <div className='steps'>

            <p>1 of 2</p>

          </div>

          <button type='button' onClick={() => this._handleNextStep()} className='btn btn--border'>Next step</button>

        </div>

      </div>

      <div className={`form-fields ${items[1] ? 'active' : ''} `}>

        <h4>We're here to help</h4>
        <div className='instructions'>Kindly share your details and our team will be in contact to assist you further.</div>

        <div className='form__row form__row--double'>

          <div>

            <label htmlFor='first-name-field'> First Name </label>

            <input type='text' name='firstname' id='first-name-field' className='form__input' onChange={this.handleChange} required />

          </div>

          <div>

            <label htmlFor='last-name-field'> Last Name </label>

            <input type='text' name='lastname' id='last-name-field' className='form__input' onChange={this.handleChange} required />

          </div>

        </div>

        <div className='form__row'>

          <label htmlFor='email-field'>Your Email</label>

          <input type='email' name='email' id='email-field' className='form__input' onChange={this.handleChange} required  />

        </div>

        <div className='form__row'>

          <label htmlFor='contact-field'> Contact Number </label>

          <input type='text' name='mobile' id='contact-field' className='form__input' onChange={this.handleChange} required  />

        </div>

        <div className='form__row'>

          <label htmlFor='contact-method-field'> Your preferred method of contact </label>

          <div className='form__radio-group'>

            <div className='form__radio'>
              <input type='radio' id='call-radio-field' name="contact_method" value="HomePhone" onChange={this.handleChange} />
              <label htmlFor='call-radio-field'>Call </label>
            </div>

            <div className='form__radio'>
              <input type='radio' id='sms-radio-field' name="contact_method" value="SMS" onChange={this.handleChange} />
              <label htmlFor='sms-radio-field'>Sms</label>
            </div>

            <div className='form__radio'>
              <input type='radio' id='email-radio-field' name="contact_method" value="Email" onChange={this.handleChange} />
              <label htmlFor='email-radio-field'>Email</label>
            </div>

          </div>

        </div>

        <div className='form__row'>

          <div className='form__checkbox'>

            <input type='checkbox' name='register' defaultChecked={this.state.register} id='newsletter-field' className='form__checkbox' onChange={this.handleChange}  />
            <label htmlFor='newsletter-field'>By ticking this box, you consent to receive marketing communications from Kollosche as per our <strong><Link to='/privacy-policy/'>Privacy Policy. </Link></strong> </label>

          </div>

        </div>

        <div className='form__row form__row--submit'>

          <div className='steps'>

            <p>2 of 2</p>

          </div>

          <div className='form__row-buttons'>

            <button type='button' onClick={() => this._handleBackStep()} className='btn btn--border'>Back</button>

            <button type='submit' className='btn btn--border btn-secondary'  disabled={this.state.isSubmitting}>Sign up</button>

          </div>

        </div>

      </div>

      </form>
    )
  }
}

export default OffMarketForm
